/* eslint-disable no-irregular-whitespace */
<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{padding:0;margin:0;}
body{
  overflow-x: hidden;
}
/* ::-webkit-scrollbar {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue